import { ALLACCOUNTSSUMMARY__MUTATIONS } from "../mutation-types";
import { ALLACCOUNTSSUMMARY__ACTIONS } from "../action-types";
import { ALLACCOUNTSSUMMARY__API } from "@/_helpers/urls";
import http from "@/_helpers/http";

// State
const state = {
  accountsummary: [],
  clientsummary: [],
  businessLevel: null,
  totalCommissionSum: 0.00,
  pagination: {
    total: 0,
    perPage: 10,
    currentPage: 1,
    lastPage: 1
  }
};

const getters = {};

// Mutations
const mutations = {
  [ALLACCOUNTSSUMMARY__MUTATIONS.ALLACCOUNTSSUMMARY](state, data) {
    state.accountsummary = data?.data;
    state.pagination = data?.data?.pagination;
  },
  [ALLACCOUNTSSUMMARY__MUTATIONS.CLINTSSUMMARY](state, data) {
    state.clientsummary = data?.data?.clients;
    state.pagination = data?.data?.pagination;
    state.businessLevel = data?.data?.businessLevel || 10;
    state.totalCommissionSum = data?.data?.totalCommissionSum || 0.00;
  },
};

// Actions
const actions = {
  async [ALLACCOUNTSSUMMARY__ACTIONS.ALLACCOUNTSSUMMARY]({ commit }, parameter) {
    try {
      const {
        level = null,
        page = 1,
        limit = 10,
        search = "",
      } = parameter || {};

      const parsedLevel = (() => {
        if (
          level === null ||
          level === undefined ||
          level === "" ||
          String(level).toLowerCase() === "null" ||
          String(level).toLowerCase() === "all" ||
          String(level).toLowerCase() === "all level"
        ) {
          return null;
        }

        const s = String(level).trim();
        const m = s.match(/level\s*(\d+)/i);
        if (m) return Number(m[1]);

        const n = Number(s);
        return Number.isFinite(n) ? n : null;
      })();

      const qsObj = {
        page: String(page),
        limit: String(limit),
        search: String(search || ""),
      };

      if (parsedLevel !== null) qsObj.level = String(parsedLevel);

      const queryParams = new URLSearchParams(qsObj).toString();

      const { data } = await http().get(
        ALLACCOUNTSSUMMARY__API.ALLACCOUNTSSUMMARY + (queryParams ? `?${queryParams}` : "")
      );

      commit(ALLACCOUNTSSUMMARY__MUTATIONS.ALLACCOUNTSSUMMARY, data);
    } catch (error) {
      console.error("Error fetching trades account summary:", error);
    }
  },

  async [ALLACCOUNTSSUMMARY__ACTIONS.CLINTSSUMMARY]({ commit }, parameter) {
    try {
      const {
        level = null,
        page = 1,
        limit = 10,
        search = "",
      } = parameter || {};

      const parsedLevel = (() => {
        if (!level || level === "All Level" || String(level).toLowerCase() === "null") return null;

        const s = String(level).trim();
        const m = s.match(/level\s*(\d+)/i);
        if (m) return m[1]; // "1"

        const n = Number(s);
        return Number.isFinite(n) ? String(n) : null;
      })();

      const qsObj = {
        page: String(page),
        limit: String(limit),
        search: String(search),
      };

      if (parsedLevel) qsObj.level = parsedLevel;

      const queryParams = new URLSearchParams(qsObj).toString();

      const { data } = await http().get(
        ALLACCOUNTSSUMMARY__API.CLINTSSUMMARY + (queryParams ? `?${queryParams}` : "")
      );

      commit(ALLACCOUNTSSUMMARY__MUTATIONS.CLINTSSUMMARY, data);
    } catch (error) {
      console.error("Error fetching client summary:", error);
    }
  }

};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  mutations,
  actions,
  getters,
};
